import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService, AI_DETECTION_ENDPOINTS } from '@core';
import { DetectionTaskStarted, DetectionTaskStatusResponse } from '@core/models/project.models';
import { ApiResponse } from '@core/models/api.models';

@Injectable()
export class AiDetectionApiService {
  private readonly api = inject(ApiService);

  triggerPreProcess(
    projectId: number,
    fileTypeId: number,
    scale?: string,
  ): Observable<ApiResponse<DetectionTaskStarted>> {
    const endpoint = AI_DETECTION_ENDPOINTS[fileTypeId]?.preProcess;
    if (!endpoint) {
      throw new Error(`No pre-process endpoint configured for file type ${fileTypeId}.`);
    }

    return this.api.post<DetectionTaskStarted>(endpoint, {
      project_id: projectId,
      file_type_id: fileTypeId,
      ...(scale ? { scale } : {}),
    });
  }

  pollStatus(fileTypeId: number, taskId: string): Observable<DetectionTaskStatusResponse> {
    const endpoint = AI_DETECTION_ENDPOINTS[fileTypeId]?.taskStatus;
    if (!endpoint) {
      throw new Error(`No task-status endpoint configured for file type ${fileTypeId}.`);
    }

    return this.api.get<DetectionTaskStatusResponse>(
      `${endpoint}/${taskId}`,
    ) as unknown as Observable<DetectionTaskStatusResponse>;
  }
}
